module.exports = __webpack_public_path__ + "141d4a85/img/settings-icon.121d9519.svg";